import React, { useEffect } from 'react';
import TCRoutes from './Routes/Router';
import { logout, monitorTokenExpiration } from '../Config/Auth';
import { AdminProfileProvider } from './Context/AdminProfileImage/AdminProfileImage';
import { SidebarProvider } from './Context/SidebarContext/SidebarContext';
import { TrackingProvider } from './Context/TrackingContext/TrackingContext';
import ProtectedRoute from './Routes/ProtectedRoute';
import { NotificationProvider } from './Context/NotificationContext/NotificationContext';

const App = () => {
  useEffect(() => {
    monitorTokenExpiration(logout);
  }, []);

  return (
    <ProtectedRoute>
      <SidebarProvider>
        <AdminProfileProvider>
          <TrackingProvider>
            <NotificationProvider>
              <TCRoutes />
            </NotificationProvider>
          </TrackingProvider>
        </AdminProfileProvider>
      </SidebarProvider>
    </ProtectedRoute>
  );
};

export default App;
